'use strict';

var d3 = require('d3');
var ChartExample = function ChartExample(AbstractChart, scalesService, chartMultiBrush, chartGroups, chartSimpleBars, chartSimpleLine, chartTiles, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var brush = chartMultiBrush();
    var groups = chartGroups('d1', formatters.tooltipFormatter, true);
    var simpleBars = chartSimpleBars('m1');
    var tiles = chartTiles('d1', 'm2');
    var simpleLine = chartSimpleLine('d1', 'm2');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    self.render = function (data, range) {
      this.initChart(data, range, chartParams);
      self.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], self.scales);
      this.callForDataGroup([yAxisLeft, groups, simpleBars, tiles, simpleLine, xAxis], self.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    self.domainChange = function (range) {
      self.render(this.data, range);
    };
    self.withMetric = function (metric) {
      yAxisLeft.label(metric);
      return this;
    };
    self.setInitialSelection = function (range) {
      brush.setSelection(range);
    };
    brush.on('brushchange', function (ranges) {
      self.brushChangeAction(ranges, groups);
      dispatch.rangechange(ranges);
    });
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartExample.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsMultiBrush', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsSimpleLine', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = ChartExample;